import { Button } from '@factorialco/factorial-one-react'
import { Dropdown } from '@factorialco/factorial-one-react/dist/experimental'
import {
  Add,
  Bullet,
  Check,
  GroupBy,
  Numbers,
  Star,
  TextSize,
} from '@factorialco/factorial-one-react/icons/app'
import { FormsElementTypeEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

const HeaderSidebarDropdown = ({
  onAddElement,
}: {
  onAddElement: (type: FormsElementTypeEnum, sectionId: string | null) => void
}) => {
  return (
    <Dropdown
      items={[
        {
          label: i18n.t('forms.modals.elements.single_choice'),
          icon: Bullet,
          onClick: () => onAddElement('select', null),
        },
        {
          label: i18n.t('forms.modals.elements.multiple_choice'),
          icon: Check,
          onClick: () => onAddElement('multiselect', null),
        },
        {
          label: i18n.t('forms.modals.elements.rating'),
          icon: Star,
          onClick: () => onAddElement('rating', null),
        },
        {
          label: i18n.t('forms.modals.elements.numeric'),
          icon: Numbers,
          onClick: () => onAddElement('number', null),
        },
        {
          label: i18n.t('forms.modals.elements.text'),
          icon: TextSize,
          onClick: () => onAddElement('text', null),
        },
        {
          label: i18n.t('forms.modals.elements.section'),
          icon: GroupBy,
          onClick: () => onAddElement('section', null),
        },
      ]}
    >
      <Button icon={Add} label={i18n.t('forms.modals.actions.add')} variant="outline" size="sm" />
    </Dropdown>
  )
}

export default HeaderSidebarDropdown
